<template>
  <FC2
    :id="id"
    :label="label"
    :fcType="'fc2-radio'"
    :height="heightC"
    :textarea="textarea"
    :bb="bb"
    :valued="valued"
  >
    <div class="radio-list">
      <div v-for="op of options" class="radio-item" :key="op.value">
        <label class="radio-circle">
          <div :class="`radio-label ${disabled ? 'disabled' : ''}`" :for="id">{{op.text}}</div>
          <input
            type="radio"
            :checked="op.value == value"
            :name="id"
            @input="e => onInputChange(op)"
            :disabled="disabled"
          />
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </FC2>
</template>
<script>
import { toSnakeCase, uuidv4 } from "../../utility";
import FC2, { FC2PropTypes } from "../fc2/fc2";
import { INPUT_HEIGHT, FC2Mixin } from "../fc2";

const RADIO_HEIGHT = 18;

export default {
  components: {
    FC2,
  },
  props: {
    ...FC2PropTypes,
    options: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [FC2Mixin()],
  mounted: function () {},
  computed: {
    heightC: function () {
      return this.options.length > 0 ? this.options.length * RADIO_HEIGHT + 10 : INPUT_HEIGHT;
    },
  },
  data: function () {
    return {
      _id: uuidv4(),
    };
  },
  methods: {
    onInputChange: function (event) {
      this.emit("input", event.value, []);
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.fc2-radio {
  .radio-list {
    margin-top: 5px;
    display: flex;
    flex-direction: column;

    .radio-item {
      display: flex;
      height: 18px;

      .radio-circle {
        // display: flex;
        // flex-direction: column;
        // justify-content: center;

        display: block;
        position: relative;
        padding-left: 15px;
        // margin-bottom: 12px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          left: 20px;
          top: 0px;

          &:disabled {
            // opacity: 0.5;
          }
        }

        /* Create a custom radio button */
        .checkmark {
          margin-top: 0px;

          position: absolute;
          top: 4px;
          left: 0;
          height: 12px;
          width: 12px;
          background-color: #eee;
          border-radius: 50%;          
        }

        /* On mouse-over, add a grey background color */
        &:hover {
          input ~ .checkmark {
            background-color: #ccc;
          }
        }

        /* When the radio button is checked, add a blue background */
        input:checked ~ .checkmark {
          background-color: var(--bc-darker);
          margin-top: 0px;
        }

        /* Create the indicator (the dot/circle - hidden when not checked) */
        .checkmark:after {
          content: "";
          position: absolute;
          // display: none;
          opacity: 0;

          top: 5px;
          left: 5px;
          width: 2px;
          height: 2px;
        }

        /* Show the indicator (dot/circle) when checked */
        input:checked ~ .checkmark:after {
          display: block;
          opacity: 1;

          // top: 3px;
          // left: 3px;
          // width: 6px;
          // height: 6px;

          // top   : 5px;
          // left  : 5px;
          // width : 2px;
          // height: 2px;

          transform: scale(2.7);
        }

        /* Style the indicator (dot/circle) */
        .checkmark:after {
          border-radius: 50%;
          background: white;

          transition: opacity 200ms ease-out, transform 200ms ease-out;
        }
        .radio-label {
          margin-left: 8px;
          &.disabled {
            opacity: 0.5;
          }
        }
      }
    }
  }
}
</style>